import { Injectable } from '@angular/core';

import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  /**
   *@param {MatSnackBar} _snackBar
   */
  constructor(private _snackBar: MatSnackBar) { }

  // -----------------------------------------------------------------------------------------------------
  // @ Private methods
  // -----------------------------------------------------------------------------------------------------

  private buildOptions({
    duration = 5000,
    horizontalPosition = 'center',
    verticalPosition = 'bottom',
  } = {}): any {
    return { duration, horizontalPosition, verticalPosition };
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  toast(message: string, action?: string, duration: number = 5000): void {
    this._snackBar.open(
      message, 
      action,
      this.buildOptions({
        duration
      })
    );
  }

  success(message: string, duration: number = 5000): void {
    this._snackBar.open(
      message,
      null,
      this.buildOptions({
        duration
      })
    );
  }

  error(message: string, duration: number = 5000): void {
    this._snackBar.open(
      message,
      null,
      this.buildOptions({
        duration
      })
    );
  }

  warning(message: string, duration: number = 5000): void {
    this._snackBar.open(
      message,
      null,
      this.buildOptions({
        duration
      })
    );
  }

  info(message: string, duration: number = 5000): void {
    this._snackBar.open(
      message,
      null,
      this.buildOptions({
        duration
      })
    );
  }
}
